// extracted by mini-css-extract-plugin
export var ovalBlock = "InformationCard-module--oval-block--8e1de";
export var ovalContainer = "InformationCard-module--oval-container--37c11";
export var ovalTitle = "InformationCard-module--oval-title--8669a";